import PropTypes from 'prop-types';
import React from 'react';

const FileField = props => (
	<div className="form-element form-element__upload">
		<label className="form-element__upload-control">
			<span className="label font-proxima-nova-semibold">{props.placeholder}</span>
			<input type="file" onChange={e => props.addFileToUpload(e.target.files[0], props.input.onChange)} />
		</label>
		<span className="info">{props.info}</span>
	</div>
);

FileField.propTypes = {
	placeholder: PropTypes.string,
	input: PropTypes.object,
	onChange: PropTypes.func,
	addFileToUpload: PropTypes.func,
	info: PropTypes.string
};

export default FileField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/file-field.js